import { BreakPoint } from '../../../../types/mutual-fund-detail.types'
import { convertSlabsToNameValueData } from '../../../../utils/mutualFundDetail'
import { fixedDigitsAndFormatNumberWithCurrency, roundOffAndFormatNumberWithCurrency } from '../../../../utils/utils'
import NameValueTable from '../../../ui-components/NameValueTable'
import BottomSheetContent from '../../BottomSheetContent'

export const ExitLoadBottomSheet = ({
  heading,
  onDismiss,
  amount,
  exitLoad,
  exitLoadSlabs
}: {
  heading: string
  onDismiss: () => void
  amount: number
  exitLoad: number
  exitLoadSlabs: BreakPoint[] | null
}) => {
  return (
    <BottomSheetContent
      heading={heading}
      onDismiss={onDismiss}
      bottomSheetHeadingClassName='!font-[500] !mb-5'
      bottomSheetBodyClassName='!px-0 !pb-4'
    >
      <ExitLoadBottomSheetContent
        testLocator='MFE_ENTER_AMOUNT_BS_EXIT_LOAD'
        amount={amount}
        exitLoad={exitLoad}
        exitLoadSlabs={exitLoadSlabs ?? []}
      />
    </BottomSheetContent>
  )
}

export const ExitLoadBottomSheetContent = ({
  testLocator,
  amount,
  exitLoad,
  exitLoadSlabs
}: {
  testLocator: string
  amount: number
  exitLoad: number
  exitLoadSlabs: BreakPoint[]
}) => {
  return (
    <div test-locator={testLocator} className='flex flex-col px-5 border-t border-[#F0F4F7]'>
      <div className='flex flex-col pt-5'>
        <NameValueTable
          data={[
            {
              name: 'Withdrawal amount',
              value: `${roundOffAndFormatNumberWithCurrency(amount, true, 'floor')}`
            },
            {
              name: 'Exit load',
              value: `${roundOffAndFormatNumberWithCurrency(exitLoad)}`
            },
            {
              name: 'Pre-tax value',
              value: `${exitLoad > 1
                ? roundOffAndFormatNumberWithCurrency(amount - exitLoad)
                : roundOffAndFormatNumberWithCurrency(amount - exitLoad)
                }`
            }
          ]}
          gap={14}
        />
        <div className='text-[#8E9393] text-[13px] font-[400]'>This gets credited to your bank</div>
        <div className='w-full pt-5 pb-4'>
          <div className='w-full h-[1px] bg-[#F0F4F7]' />
        </div>
        <div className='text-[#6A6E6E] text-[13px] font-[400] pb-5'>
          Above exit load is a weighted average based on slabs applicable to the withdrawal amount.
        </div>
      </div>
      {exitLoadSlabs && exitLoadSlabs?.length > 0 && (
        <div className='rounded-[12px] bg-[#F0F4F7] px-4 py-3'>
          <NameValueTable
            data={convertSlabsToNameValueData(
              exitLoadSlabs ?? [],
              {
                FIRST: 'If redeemed within',
                BETWEEN: 'If redeemed between',
                LAST: 'If redeemed after'
              },
              {
                FIRST: '',
                BETWEEN: '',
                LAST: ''
              }
            )}
            gap={8}
          />
        </div>
      )}
    </div>
  )
}
